<template>
  <button class="btn btn-white"
          v-on="listeners"
  >
    <template v-if="icon !== ''">
      <i class="icon" :class="icon"></i>
    </template>
    <slot/>
  </button>
</template>

<script>
  export default {
    name: 'BaseButton',
    props: {
      icon: {type: String, default: ''},
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
        }
      },
    },
  }
</script>
